import lozad from 'lozad';

export default {
  init() {
    const observer = lozad();
    observer.observe();

    //Eseményre jelentkezés form
    if ($('.event-ticket-form').length > 0) {
        var version = detectIE();

        $('.datepicker').datepicker({
            'dateFormat': 'yy-mm-dd',
            'beforeShowDay': $.datepicker.noWeekends,

        });

        $(document).on('change', '.datepicker', function () {
            var day = new Date($('.datepicker').val());

            if (day.getDay() == 2 || day.getDay() == 5) {
                $(this).closest('.form-inline').find('select').find('.added').remove();

                $(this).closest('.form-inline').find('select').append($('<option class=\'added\'></option>').attr('value', '16:00').text('16:00'));
                $(this).closest('.form-inline').find('select').append($('<option class=\'added\'></option>').attr('value', '17:00').text('17:00'));
            } else {
                $(this).closest('.form-inline').find('select').find('.added').remove();
            }
        });

        if (version !== false && version < 12 && $('.vakacio').length > 0) {
            alert('Ez a böngésző nem támogatott. Amennyiben mégis az Internet Explorer böngészőt használja az űrlap kitöltéséhez, kérjük, minden mezőt töltsön ki, ellenkező esetben a regisztrációja érvénytelen. Megértését köszönjük!!');
        }

        $(document).on('submit', '.event-ticket-form', function () {
            $('.event-ticket-form input[type=submit]').attr('disabled', 'disabled');

            $.ajax({
                url: ajax_url.ajax_url,
                method: 'POST',
                data: {
                    action: 'save_event_ticket_form',
                    formData: $(this).serializeArray(),
                    eventID: $(this).attr('data-event-id'),
                },
            }).done(function (msg) {
                //console.log(msg);
                if (msg == '10') {
                    $('.alert-success').html('<strong>Köszönjük regisztrációját! E-mailben elküldtük Önnek a regisztrációval kapcsolatos információkat!</strong><br>').show();
                    $('.alert-danger').hide();
                    $(document).scrollTop(0);
                    $('.event-ticket-form').each(function () {
                        $(this)[0].reset();
                    });
                } else if (msg.indexOf(':') >= 0) {
                    $('.alert-danger').html('Sajnáljuk, az ' + msg + ' időpontú eseményre minden hely elfogyott!').show();
                } else if (msg == '1') {
                    $('.alert-danger').html('Sajnáljuk, az eseményre minden hely elfogyott!').show();
                } else {
                    $('.alert-danger').html(' regsiztráció során hiba lépett fel!').show();
                }

                $('.event-ticket-form input[type=submit]').removeAttr('disabled');
            });

            return false;
        });

        $(document).on('change', '.kids-number', function () {
            var $number = $(this).val();
            $('.kid-row-wrap').html('');

            for (var i = 1; i <= $number; i++) {
                var $clone = $('.kid-row-orig').clone();

                $clone.find('input:text').val('');
                $clone.find('select').val('');

                $clone.addClass('kid-row').removeClass('kid-row-orig').css('display', 'flex');

                $('.kid-row-wrap').append($clone[0]);
            }

            return false;
        });

        $(document).on('click', '.add-date', function () {
            var $clone = $('.date-row-orig').clone();
            $clone.find('input:text').val('');
            $clone.find('select').val('');

            $clone.addClass('date-row').removeClass('date-row-orig');

            $(this).before($clone[0]);

            $('.datepicker').datepicker({
                'dateFormat': 'yy-mm-dd',
            });

            return false;
        });

        $(document).on('click', '.remove-date-row', function () {
            $(this).closest('.date-row').remove();

            return false;
        });
    }

    if ($('#tribe-events').length > 0 && typeof tribe_ev !== 'undefined') {
      $(tribe_ev.events).on('tribe_ev_ajaxSuccess', function () {
        location.reload();
      });
    }
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    return false;
}

	$('#desktop_menu_toggle').on('click', function (e) {
		e.preventDefault();
		let navbarCollapse = $('.desktop_menu');
		navbarCollapse.slideToggle('fast');
		navbarCollapse.toggleClass('show');

		if (navbarCollapse.hasClass('show')) {
			$(this).attr('aria-expanded', 'false');
		} else {
			$(this).attr('aria-expanded', 'true');
		}
	});

  $('#menu-toggle').on('click', function (e) {
    e.preventDefault();
    let navbarCollapse = $('.nav-menu');
    navbarCollapse.slideToggle('fast');
    navbarCollapse.toggleClass('show');

    if (navbarCollapse.hasClass('show')) {
      $(this).attr('aria-expanded', 'false');
      $(this).addClass('opened');
      $('#menu-toggle #nav-mobile-icons').addClass('open');
    } else {
      $(this).attr('aria-expanded', 'true');
      $(this).removeClass('opened');
      $('#menu-toggle #nav-mobile-icons').removeClass('open');
    }
  });

  $('.nav-item').each(function () {
    let $item = $(this);
    let $subNav = $item.children('.sub-nav');

    if ($subNav.length) {
      let $link = $item.children('.nav-link');

      $link.on('click', function (e) {
        if ($(window).width() < 1024) {
          e.preventDefault();

          let isOpen = $subNav.hasClass('show');

          $('.sub-nav').not($subNav).removeClass('show').slideUp('fast');

          $subNav.toggleClass('show');
          $subNav.slideToggle('fast');

          $link.attr('aria-expanded', !isOpen);
        }
      });
    }
  });

// back to top
$('#backtotop').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 200);
});


// WEBPACK FOOTER //
// ./scripts/routes/common.js